import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../utils/api';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function SignUpForm() {
  const navigate = useNavigate();

  const [email, setEmail]                             = useState('');
  const [password, setPassword]                       = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [companyId, setCompanyId]                     = useState('');
  const [error, setError]                             = useState('');
  const [loading, setLoading]                         = useState(false);

  // toggles for password visibility
  const [showPassword, setShowPassword]                           = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await createUser({
        email,
        password,
        password_confirmation: passwordConfirmation,
        company_id: companyId,
      });

      // instead of logging in immediately, redirect to login page
      // and let the admin enable the new account
      navigate('/');
      alert('Your account has been created! Please wait for an admin to activate it before logging in.');
    } catch (err) {
      setError(err.message || 'Sign up failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h3 className="mb-4">Sign Up</h3>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        {/* Email */}
        <div className="mb-3">
          <label htmlFor="signup-email" className="form-label">Email</label>
          <input
            type="email"
            id="signup-email"
            className="form-control"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Password */}
        <div className="mb-3 password-input-wrapper">
          <label htmlFor="signup-password" className="form-label">Password</label>
          <input
            type={showPassword ? 'text' : 'password'}
            id="signup-password"
            className="form-control"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(v => !v)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {/* Confirm Password */}
        <div className="mb-3 password-input-wrapper">
          <label htmlFor="signup-password-confirm" className="form-label">
            Confirm Password
          </label>
          <input
            type={showPasswordConfirmation ? 'text' : 'password'}
            id="signup-password-confirm"
            className="form-control"
            value={passwordConfirmation}
            onChange={e => setPasswordConfirmation(e.target.value)}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPasswordConfirmation(v => !v)}
          >
            {showPasswordConfirmation ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {/* Company ID */}
        <div className="mb-3">
          <label htmlFor="signup-company-id" className="form-label">Company ID</label>
          <input
            type="text"
            id="signup-company-id"
            className="form-control"
            value={companyId}
            onChange={e => setCompanyId(e.target.value)}
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? 'Signing Up...' : 'Sign Up'}
        </button>
      </form>
    </div>
  );
}
